/*!
* This is property of Soft4Net and part of the Soft4Shop system.
* All rights are reserved, it's no freeware - get in touch to get further information.
*
* @author		Soft4Net Dev-Team\<info@soft4net.pl\>
* @version		1.0.0 01-Jan-13
* @copyright	Copyright (c) 2013-2015 by Soft4Net. All rights reserved. (http://www.soft4net.pl)
*/

import { navigate } from "gatsby-plugin-intl"

export default ($, window, document, undefined) => {

    String.prototype.rot13 = function()
    {
        return this.replace(/[a-zA-Z]/g, function(c)
        {
            return String.fromCharCode((c <= "Z" ? 90 : 122) >= (c = c.charCodeAt(0) + 13) ? c : c - 26);
        });
    };

    String.prototype.hashCode = function()
    {
        let hash = 0, i, chr;
        if (this.length === 0) return hash;
        for (i = 0; i < this.length; i++) {
            chr   = this.charCodeAt(i);
            hash  = ((hash << 5) - hash) + chr;
            hash |= 0; // Convert to 32bit integer
        }
        return hash;
    };

    let g_soft4NetFrontConfig = {

        body: $('body'),

        bootstrapConfig: {
            // Bootsrap 4
            breakpoint:    {
                sm: 576,
                md: 768,
                lg: 992,
                xl: 1200,
            }
        },

        owlCarouselOptions:
        {
            core: {
                // nestedItemSelector: 'wp-image-*',
                nestedItemSelector: 'blocks-gallery-item',
                // stageElement:   'ul',
                // itemElement:    'li',

                lazyLoad: true,
                // loop: true,
                // mouseDrag: false,
                
                // margin:             1,
                // autoplay:           true,
                // autoplayTimeout:    7000,
                // autoplayHoverPause: true,
                navRewind: false,
                navText: [
                    // '<i class="fa fa-angle-left" aria-hidden="true"></i>',
                    // '<i class="fa fa-angle-right" aria-hidden="true"></i>'
                    '<i class="fas fa-chevron-left"></i>',
                    '<i class="fas fa-chevron-right"></i>'
                ],
                responsiveClass: true,
                responsive: {
                    0:  {
                        items:  1
                    }
                },

                // Accessible OWL Carousel, @see: https://codepen.io/AlexRebula/pen/yOjVvY START
                onInitialized: function (event) {
                    let $carouselContainer = $(event.target);

                    $carouselContainer.find('.owl-item').attr('aria-selected', 'false');
                    $carouselContainer.find('.owl-item.active').attr('aria-selected', 'true'); // let screen readers know an item is active
        
                    // apply meta info to next and previous buttons and make them focusable
                    $carouselContainer.find('.owl-prev').attr('role', 'button').attr('title', 'Previous');
                    $carouselContainer.find('.owl-next').attr('role', 'button').attr('title', 'Next');
// $('#owl-single-example, .owl-prev, .owl-next').attr('tabindex', '0');

// Soft4Net START
                    $carouselContainer.find('.owl-dots .owl-dot').each(function(index, value) {
                        let $this = $(this);
                        $this.children('span').text(index + 1);
                    });
// Soft4Net STOP

                    // add instructions to keyboard users that are only visible when the carousel is focused
                    $carouselContainer.find('.owl-stage-outer').append('<p class="sr-only sr-only-focusable alert alert-success show-on-focus">Use left and right arrow keys to navigate.</p>');
        
                    // listen for keyboard input
                    $(document).on('keydown', function(e){
                        let $focusedElement = $(document.activeElement),
                            singleOwl = $carouselContainer.data('owlCarousel');
                        let type = null;
                            
                            type = e.which == 39? 'next' : null
                            type = e.which == 37? 'prev' : type
                            type = e.which == 13? 'enter' : type
        
                        // if the carousel is focused, use left and right arrow keys to navigate
                        if ($focusedElement.attr('id') === 'owl-single-example') {
                            if (type == 'next') {
                                singleOwl.next();
                            } else if (type == 'prev') {
                                singleOwl.prev();
                            }
                            // if the prev and next buttons are focused, catch "Enter" and navigate in the right direction
                        } else if (type == 'enter') {
                            if ($focusedElement.hasClass('owl-next')) {
                                singleOwl.next();
                            } else if ($focusedElement.hasClass('owl-prev')) {
                                singleOwl.prev();
                            }
                        }
                    });
                },
                // let screen readers know which slide is active after navigation or reinit
                onChange : function(event) {
                    let $carouselContainer = $(event.target);
                    $carouselContainer.find('.owl-item').attr('aria-selected', 'false');
                    $carouselContainer.find('.owl-item.active').attr('aria-selected', 'true');
                }
                // Accessible OWL Carousel, @see: https://codepen.io/AlexRebula/pen/yOjVvY STOP

    /*
                // autoWidth:  true,
                // autoHeight: true,

                // animateIn:  'bounceInLeft',
                // animateOut: 'bounceOutRight',
                // animateIn:  'fadeInLeft',
                // animateOut: 'fadeOutRight',
                // animateIn:  'slideInLeft',
                // animateOut: 'slideOutRight',
                animateIn:  'fadeIn',
                animateOut: 'fadeOut',

                callbacks:  true,
                onChange: function(event)
                {
                    // When a property is going to change its value.
                    //console.log('onChange');

                    console.log(event);

                },
                onChanged: function(event)
                {
                    // When a property has changed its value.
                    //console.log('onChanged');
                    console.log(event);
                },
                onTranslate: function(event)
                {
                    // When the translation of the stage starts.
                    //console.log('onTranslate');
                    console.log(event);
                },
                onTranslated: function(event)
                {
                    // When the translation of the stage has finished.
                    //console.log('onTranslated');
                    console.log(event);
                }
    */
            },
            mainSlider: {
                loop: true,
                nav: false,
                dots: true,                
// autoplay: true,
                autoplayTimeout: 7500,
                //autoplayHoverPause: true,
                responsive: {
                    0: {
                        items: 1
                    }
                },
                animateIn:  'fadeIn',
                animateOut: 'fadeOut'
            },
            centeredSlider: {
                center: true,
                nav: false,
                dots: true,
                margin: 5,
                //items: 1,
                responsive: {
                    0: {
                        items: 1
                    },
                    768: {
                        items: 2
                    }
                }
            },
            standardSlider: {
                nav: true,
                dots: false,
// autoplay: true,
                autoplayTimeout: 5000,
                margin: 15,
                responsive: {
                    0: {
                        items: 1
                    },
                    768: {
                        items: 2
                    },
                    992: {
                        items: 4
                    },
                    1200: {
                        items: 4
                    }
                }
            },
            testimonialsSlider: {
                nestedItemSelector: false,
                autoplay: true,
                autoplayTimeout: 5000,
                autoplayHoverPause: true,
                loop: true,
                nav: true,
                dots: true,
                animateIn:  'fadeIn',
                animateOut: 'fadeOut'
            },
        },

        owlCarousel: function(sSliderType, sSliderSelector = null)
        {
            try {
                let carouselConfigItem = $.extend({}, g_soft4NetFrontConfig.owlCarouselOptions.core, g_soft4NetFrontConfig.owlCarouselOptions[sSliderType]);
                //let carouselConfigItem = g_soft4NetFrontConfig.owlCarouselOptions.sSliderType;

                // console.log(sSliderType);
                // console.log(carouselConfigItem);
                // console.log('');

                if (null === sSliderSelector) {
                    sSliderSelector = '.' + sSliderType;
                }

                let $owl = $(sSliderSelector).owlCarousel(carouselConfigItem);

                // $owl.onResize();
                // $(window).resize();
                // $owl.trigger('refresh.owl.carousel');

            } catch(err) {
                // Error handling
            }

            //http://www.owlcarousel.owlgraphic.com/demos/events.html
/*
            $value.on('initialize.owl.carousel initialized.owl.carousel ' +
                'initialize.owl.carousel initialize.owl.carousel ' +
                'resize.owl.carousel resized.owl.carousel ' +
                'refresh.owl.carousel refreshed.owl.carousel ' +
                'update.owl.carousel updated.owl.carousel ' +
                'drag.owl.carousel dragged.owl.carousel ' +
                'translate.owl.carousel translated.owl.carousel ' +
                'to.owl.carousel changed.owl.carousel', function(e) {
                    $('.' + e.type)
                        .removeClass('secondary')
                        .addClass('success');
                    window.setTimeout(function() {
                        $('.' + e.type)
                        .removeClass('success')
                        .addClass('secondary');
                    }, 500);
                        console.log(e);
                });
*/
/*
            $value
                .on('change.owl.carousel', function(event)
                {
                    //console.log(event);
                })
                .on('changed.owl.carousel', function(event)
                {
                    //console.log(event);
                })
                .on('translate.owl.carousel', function(event)
                {
                    //console.log(event);
                    //console.log($(event.target));
                    //$(event.target).find('.owl-item.active h2').addClass('animated');
                })
                .on('translated.owl.carousel', function(event)
                {
                    //console.log(event);
                    //$(event.target).find('.owl-item.active h2').removeClass('animated');
                });
*/

            return this;
        },

        waypoints: function()
        {
            let waypointOffset = '70%';

            $('#soft4cms').waypoint(function() {
                $('#soft4cms').addClass('animated fadeInRight');
            }, {
                offset: waypointOffset
            });

            return this;
        },
/*
        servicePopupScroll: function()
        {
            let animation = 'fadeIn',
                ps = null,
                $serviceBoxes = $('.services .row .col');

            $serviceBoxes.each(function(index, value) {
                $serviceBox = $(value);
                $serviceBoxPopupScroll = $serviceBox.find('.popup .content');
                ps = new PerfectScrollbar($serviceBoxPopupScroll[0], {
                    // wheelSpeed: 2,
                    // wheelPropagation: false,
                    // minScrollbarLength: 20
                });

                $serviceBox.find('figure')
                    .on('click', function(event) {
                        $serviceBoxPopupScroll.scrollTop = 0;
                        ps.update();
                        $(this).parent().addClass('hovered');
                    })
                    .next('.popup').find('.close').on('click', function(event)
                    {
                        $(this).closest('.hovered').removeClass('hovered');
                        event.preventDefault();
                        event.stopPropagation();
                        //return false;
                    });
            });

    //             $('.services .row > div')
    //                 .on('mouseenter', function(event)
    //                 {
    //                     let $this = $(this);
    //
    //                     //g_soft4NetFrontConfig.randomAnimation = items[Math.floor(Math.random() * items.length)];
    //                     //g_soft4NetFrontConfig.randomAnimation = g_soft4NetFrontConfig.closestEdge(event.pageX, event.pageY, $this.width(), $this.height());
    //
    //                     g_soft4NetFrontConfig.randomAnimation = '';
    //
    //                     //$this.find('.popup').animateCss('flipInX');
    //                     $this.find('.popup').addClass('animated ' + animation + g_soft4NetFrontConfig.randomAnimation);
    //
    //
    //                 }).on('mouseleave', function(event)
    //                 {
    //                     let $this = $(this);
    //                     //$this.find('.popup').removeClass('animated ' + animation + g_soft4NetFrontConfig.randomAnimation);
    //                 });

            return this;
        },
*/
/*
        fancybox: function()
        {
            $('.youtube-media').on('click', function(e)
            {
                let jWindow = $(window).width();
                if (jWindow <= 768) {
                    return;
                }

                $.fancybox({
                    href:       this.href,
                    padding:    4,
                    type:       'iframe',
                    'href':     this.href.replace(new RegExp("watch\\?v=", "i"), 'v/'),
                    beforeLoad: function()
                    {
                        player.pauseVideo();
                    },
                    beforeClose: function()
                    {
                        player.playVideo();
                    }
                });

                return false;
            });

    //        $('a.single_image').fancybox({
    //            padding:    4
    //        });

            return this;
        },
*/
/*
        updateBootstrapMenu: function()
        {
            $('ul.header-nav').find('ul.dropdown-menu')
                .prev('a').append('<span class="caret"></span>')
                .parent('li').addClass('dropdown');

            return this;
        },
*/
/*
        navTransformicon: function()
        {
            // When user clicks the Icon
            $('.nav-toggle, .overlay-invoker').on('click', function(e)
            {
                $(this).toggleClass('active');
                $($(this).data('target')).toggleClass('open');

                e.preventDefault();
            });

            // When user clicks a link
    //        $('.overlay ul li a').on('click', function()
    //        {
    //            $('.nav-toggle').toggleClass('active');
    //            $('.overlay-boxify').toggleClass('open');
    //        });

            // When user clicks outside
            $('.overlay').on('click', function()
            {
    //            $('.nav-toggle').toggleClass('active');
    //            $('.overlay-boxify').toggleClass('open');

                $('.nav-toggle, .overlay-invoker').removeClass('active');
                $(this).toggleClass('open');
            });

            return this;
        },
*/
        getMenuHorizontalOffset: function()
        {
            // let horizontalOffset;
            // if ($(window).width() >= g_soft4NetFrontConfig.bootstrapConfig.breakpoint.xs) { // non XS screen
            // if (window.innerWidth >= g_soft4NetFrontConfig.bootstrapConfig.breakpoint.sm) { // non XS screen
            //     horizontalOffset = $('header.header').outerHeight(); // target minus top menu height
            // } else { // XS screen
            //     horizontalOffset = $('header.header').outerHeight() - 58; // target minus top menu height
            // }
            let headerSelector = 'header.header';
            let horizontalOffset = $(headerSelector).outerHeight(); // target minus top menu height

            return horizontalOffset;
        },

        scrollSpy: function()
        {
            $('body').scrollspy({
                target: '#navbar-main',
                offset: g_soft4NetFrontConfig.getMenuHorizontalOffset() + 1
            });
            //$('body').scrollspy();

            return this;
        },

        gridPlacementPlugin: function()
        {
            let $gridContainer = $('.grid');
            $gridContainer.each(function(index, value)
            {

            });
        },
/*
        distMetric: function(x, y, x2, y2)
        {
            let xDiff = x - x2,
                yDiff = y - y2;

            return (xDiff * xDiff) + (yDiff * yDiff);
        },

        closestEdge: function(x, y, w, h)
        {
            let topEdgeDist = g_soft4NetFrontConfig.distMetric(x, y, w/2, 0),
                bottomEdgeDist = g_soft4NetFrontConfig.distMetric(x, y, w/2, h),
                leftEdgeDist = g_soft4NetFrontConfig.distMetric(x, y, 0, h/2),
                rightEdgeDist = g_soft4NetFrontConfig.distMetric(x, y, w, h/2),
                min = Math.min(topEdgeDist, bottomEdgeDist, leftEdgeDist, rightEdgeDist);

            switch (min) {
                case leftEdgeDist:
                    return 'Left';
                case rightEdgeDist:
                    return 'Right';
                case topEdgeDist:
                    return 'Up';
                case bottomEdgeDist:
                    return 'Down';
            }
        },
*/
        otherActions: function()
        {
            $('a.external').attr('target', '_blank');

            return this;
        },

        bootstrapMenu: function()
        {
            $('.navbar .dropdown > a').on('click', function() {
                window.location.href = this.href;
            });

            return this;
        },

        // enablePerfectScrollbar: function()
        // {
        //     let $ps = $('.scroll-container');
        //     if ($ps.length) {
        //         let aPsContainers = [];
        //         $ps.each(function(k, v) {
        //             aPsContainers.push(
        //                 new PerfectScrollbar(v, {
        //                     //wheelSpeed: 2,
        //                     wheelPropagation: true,
        //                     minScrollbarLength: 20
        //                 })
        //             );
        //         });
        //     }
        // },

        rot13: function()
        {
            let decoded = null;

            $('[data-encoded]').each(function(index)
            {
                let $this = $(this);
                decoded = $this.data('encoded').rot13();

                if (!$this.hasClass('noHrefUpdate')) {
                    this.href = this.href + decoded;
                }

                $(this).text(decoded);
            });

            return this;
        },
/*
        enableServiceTawkTo: function()
        {
            // let currentLanguage = window.drupalSettings.path.currentLanguage,
            let currentLanguage = $('#langDropdown').data('currentlocale'),
                serviceLangugeEndpointList = {
                    pl: 'https://embed.tawk.to/5ccf163ad07d7e0c6392052e/1daeid8a1',
                    en: 'https://embed.tawk.to/5ccf163ad07d7e0c6392052e/default'
                };

            let serviceLangugeEndpoint = serviceLangugeEndpointList[currentLanguage];

            let Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
            (function(){
                let s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
                s1.async=true;

                s1.src=serviceLangugeEndpoint;

                s1.charset='UTF-8';
                s1.setAttribute('crossorigin','*');
                s0.parentNode.insertBefore(s1,s0);
            })();

            return this;
        },
*/
        /**
         * @see: https://dimsemenov.com/plugins/magnific-popup/documentation.html
         * 
         * This callback method to modify source is not good for SEO?!
         */
        enableMagnificPopup: function(SOFT4NET_SOURCE_BASE_URL)
        {
            if (typeof $.fn.magnificPopup !== 'function') { 
                return this;
            }

            $('.wp-block-gallery:not(.hero)').magnificPopup({
                delegate: 'a',
                type: 'image',
                gallery: {
                    enabled: true
                }
                // We do it in React, @see: src/hooks/drupal/parseInlineImages.js
                // , callbacks: {
                //     elementParse: function(item) {
                //         // Function will fire for each target element
                //         // "item.el" is a target DOM element (if present)
                //         // "item.src" is a source that you may modify

                //         item.src = SOFT4NET_SOURCE_BASE_URL + item.src;
                //         // console.log('Parsing content. Item object that is being parsed:', item);
                //         // return item;
                //     }
                // }
            });

            return this;
        },

        /**
         * @see: https://stackoverflow.com/questions/3206050/extract-src-attribute-from-script-tag-and-parse-according-to-particular-matches
         * @see: https://stackoverflow.com/questions/2190801/passing-parameters-to-javascript-files
         */
        extractAttributesPassedToScriptTag: function()
        {
            let scriptAttributes = {};
            let $thisScript = $("script[src^='/s4n.js']");

            if (!$thisScript.length) {
                return scriptAttributes;
            }

            scriptAttributes['SOFT4NET_SOURCE_BASE_URL'] = $thisScript.attr('data-soft4net-source-base-url');

            return scriptAttributes;
        },

        getUniqueId: function()
        {
            return Date.now() + Math.random();
        },

        /**
         * @see: https://getbootstrap.com/docs/4.3/components/collapse/#via-data-attributes
         */
        transformToBootstrapAccoridion: function()
        {
            $('.wp-block-soft4net-container-block.accordion').each(function(index0, value0) {
                let $this = $(this);

                $this.attr('id', 'accordion_' + index0);
                $this.children('.card').each(function(index1, value1) {
                    let $this = $(this);
                    let $cardHeader = $this.children('.card-header');
                    let $collapse = $this.children('.collapse');

                    $cardHeader.attr('id', 'heading_' + index0 + '_' + index1);
                    $cardHeader.children('h1, h2, h3, h4, h5, h6')
                        .attr('data-toggle', 'collapse')
                        .attr('data-target', '#collapse_' + index0 + '_' + index1)
                        .attr('aria-expanded', 'true')
                        .attr('aria-controls', 'collapse_' + index0 + '_' + index1);

                    $collapse
                        .attr('id', 'collapse_' + index0 + '_' + index1)
                        .attr('aria-labelledby', 'heading_' + index0 + '_' + index1)
                        .attr('data-parent', '#accordion_' + index0);
                });        
            });

            // $('.collapse').collapse();

            return this;
        },

        extraFunctions: () => {
// console.log(`extraFunctions()`)
            // $('li.dropdown').on('click', function() {
            //   let $el = $(this);
            //   if ($el.hasClass('show')) {
            //       let $a = $el.children('a.dropdown-toggle');
            
            //       if ($a.length && $a.attr('href')) {
            //           // location.href = $a.attr('href');
            //           navigate($a.attr('href'));
            
            //           console.log('navigate')
            //       }
            //   }
            // });
            
            // const htmlLang = $('html').attr('lang');
            const htmlLang = document.getElementsByTagName("html")[0].getAttribute("lang");

            const intl = {
                locale: htmlLang,
            }
        
        
            // Make bootstrap a.dropdown-toggle that contains submenus clickable
            // $('.navbar').on('click', 'a.dropdown-toggle', function(event) {
            $('.navbar a.dropdown-toggle').on('click', function(event) {
                let $body = $('body');
                
                // do not visit link for mobile
                event.preventDefault();
            
                // <i class="fas fa-link"></i>
            
                // visit link in non mobile
                // if ($body.hasClass('screen-lg') || $body.hasClass('screen-xl')) {
                if ($body.is('.screen-lg, .screen-xl')) {
                    let $a = $(this);
                    if ($a.parent().hasClass('show')) {
                        if ($a.length && $a.attr('href')) {
                            // location.href = $a.attr('href');
                            
                            let href = $a.attr('href');
            
                                href = href.replace('/' + intl.locale, '')
            
                            navigate(href);
                            return null;
                        }
                    }
                }
            });
        
            // @see: https://bootstrapious.com/p/bootstrap-multilevel-dropdown
            // ------------------------------------------------------- //
            // Multi Level dropdowns
            // ------------------------------------------------------ //
            $("ul.dropdown-menu [data-toggle='dropdown']").on("click", function(event) {
                let $this = $(this);

// s4n START
                // allow language switcher to be clicked!!!
                if ('langDropdown' === $this.attr('id')) {
                    return true;
                }
// s4n STOP

                event.preventDefault();
                event.stopPropagation();

// console.log(`show`)
// console.log($this.next())
// console.log($this.next('ul')[0])

                $this.siblings().toggleClass('show');
                // $this.next().toggleClass('show');
                // $this.next('ul')[0].classList.toggle('show');

                if (!$this.next().hasClass('show')) {
                    $this.parents('.dropdown-menu').first().find('.show').removeClass("show");
                }
                $this.parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function(event) {
                    $('.dropdown-submenu .show').removeClass("show");
                });
        
            });
        
            // Add secific class for column with image so we can change width of this column
            const $blockHas2Columns = $('.wp-block-columns.has-2-columns .wp-block-column');
            $blockHas2Columns.children().each((index, value) => {
                const $children = $(value);
                $children.parent().addClass($children.hasClass('wp-block-image') ? `s4n-block-column-with-image` : `s4n-block-column-with-text`);
            });
        },
    };

    // export it to window object so we can access it globally
    // window.g_soft4NetFrontConfig = g_soft4NetFrontConfig;

    return g_soft4NetFrontConfig;
}
